import { Footer } from '@components/Footer';
import { Header } from '@components/Header';

import { COLORS } from '@constants/colors';
import { CONTACT_INFO } from '@constants/contact';

export const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20 flex flex-col">
      <Header showNavigation={false} showBackButton={true} />

      {/* Main Content */}
      <main className="flex-1 py-12 sm:py-16 lg:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl border border-slate-100 p-6 sm:p-8 lg:p-12">
            {/* Header */}
            <div className="text-center mb-8 sm:mb-12">
              <h1
                className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4"
                style={{ color: COLORS.primary }}
              >
                Terms & conditions
              </h1>
              <p
                className="text-base sm:text-lg"
                style={{ color: COLORS.smoke }}
              >
                Last updated: September 28, 2025
              </p>
            </div>

            {/* Content */}
            <div className="prose prose-slate max-w-none">
              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  1. Acceptance of terms
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    By accessing and using {CONTACT_INFO.company.name}'s
                    services, you accept and agree to be bound by the terms and
                    provision of this agreement. If you do not agree to abide by
                    the above, please do not use this service.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  2. About our services
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    {CONTACT_INFO.company.name} is founded by{' '}
                    {CONTACT_INFO.contact_person.full_name} who is an
                    AMFI-registered mutual fund distributor (ARN:{' '}
                    {CONTACT_INFO.amfi.arn}) providing:
                  </p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>Mutual fund distribution services</li>
                    <li>Investment advisory and planning</li>
                    <li>Portfolio review and rebalancing guidance</li>
                    <li>Financial education and market insights</li>
                  </ul>
                  <p>
                    <strong>We are distributors, not fund managers.</strong> All
                    investments are made directly with SEBI-registered mutual
                    fund companies.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  3. Investment risks and disclaimers
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                    <p className="font-semibold text-yellow-800">
                      IMPORTANT: Mutual fund investments are subject to market
                      risks. Please read all scheme-related documents carefully
                      before investing.
                    </p>
                  </div>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>Past performance does not guarantee future results</li>
                    <li>
                      Investment values can go up or down based on market
                      conditions
                    </li>
                    <li>
                      We provide guidance, but investment decisions are
                      ultimately yours
                    </li>
                    <li>Diversification does not guarantee against loss</li>
                    <li>
                      Tax implications may vary based on individual
                      circumstances
                    </li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  4. Client responsibilities
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>As our client, you agree to:</p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>
                      Provide accurate and complete information about your
                      financial situation
                    </li>
                    <li>
                      Complete KYC requirements as mandated by regulatory
                      authorities
                    </li>
                    <li>
                      Review and understand all investment documents before
                      investing
                    </li>
                    <li>
                      Inform us of any changes in your financial circumstances
                      or goals
                    </li>
                    <li>
                      Make investment decisions based on your own risk tolerance
                      and goals
                    </li>
                    <li>Comply with all applicable laws and regulations</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  5. Fees and charges
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    <strong>Distribution Services:</strong> We earn commission
                    from mutual fund companies as per SEBI regulations. This is
                    already factored into the fund's expense ratio and does not
                    involve additional charges to you.
                  </p>
                  <p>
                    <strong>Advisory Services:</strong> Any advisory fees will
                    be clearly disclosed and agreed upon before service
                    commencement.
                  </p>
                  <p>
                    <strong>Transparency:</strong> All fees and charges will be
                    clearly explained before you make any investment.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  6. Limitation of liability
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>{CONTACT_INFO.company.name} shall not be liable for:</p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>
                      Market losses or poor performance of recommended
                      investments
                    </li>
                    <li>
                      Delays or failures in processing due to technical issues
                      with fund houses
                    </li>
                    <li>
                      Changes in tax laws or regulations affecting your
                      investments
                    </li>
                    <li>
                      Decisions made by you contrary to our recommendations
                    </li>
                    <li>Force majeure events beyond our reasonable control</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  7. Regulatory compliance
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    We are committed to maintaining the highest standards of
                    regulatory compliance:
                  </p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>
                      AMFI registration and compliance with all AMFI guidelines
                    </li>
                    <li>SEBI regulations for mutual fund distribution</li>
                    <li>
                      KYC and AML compliance as per regulatory requirements
                    </li>
                    <li>Regular training and certification updates</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  8. Privacy and confidentiality
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    We are committed to protecting your privacy and maintaining
                    confidentiality of your personal and financial information.
                    Please refer to our{' '}
                    <a
                      href="/privacy-policy"
                      className="text-blue-600 hover:underline"
                    >
                      privacy policy
                    </a>{' '}
                    for detailed information.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  9. Termination
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    Either party may terminate this relationship with reasonable
                    notice. Upon termination:
                  </p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>Your existing investments remain unaffected</li>
                    <li>
                      You may choose to transfer your investments to another
                      distributor
                    </li>
                    <li>
                      We will provide necessary assistance for smooth transition
                    </li>
                    <li>
                      Confidentiality obligations continue even after
                      termination
                    </li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  10. Governing law and disputes
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    These terms are governed by Indian law. Any disputes will be
                    resolved through:
                  </p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>First, good faith negotiations between parties</li>
                    <li>
                      If unresolved, arbitration as per Indian Arbitration Act
                    </li>
                    <li>
                      Courts in {CONTACT_INFO.address.city} shall have exclusive
                      jurisdiction
                    </li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  11. Changes to terms
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    We may update these terms from time to time to reflect
                    changes in our services or regulatory requirements. We will
                    notify you of significant changes and the updated terms will
                    be posted on our website.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2
                  className="text-xl sm:text-2xl font-semibold mb-4"
                  style={{ color: COLORS.primary }}
                >
                  12. Contact information
                </h2>
                <div
                  className="space-y-4 text-sm sm:text-base"
                  style={{ color: COLORS.charcoal }}
                >
                  <p>
                    For any questions about these terms or our services, please
                    contact us:
                  </p>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p>
                      <strong>Name:</strong>{' '}
                      {CONTACT_INFO.contact_person.full_name}
                    </p>
                    <p>
                      <strong>Email:</strong> {CONTACT_INFO.email.legal}
                    </p>
                    <p>
                      <strong>Phone:</strong> {CONTACT_INFO.phone.display}
                    </p>
                    <p>
                      <strong>Address:</strong> {CONTACT_INFO.address.full}
                    </p>
                    <p>
                      <strong>AMFI ARN:</strong> {CONTACT_INFO.amfi.arn}
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsConditions;
